import React from 'react'
import { Chip } from '@mui/material'

export const WorkShiftChip = ({ shift, size = 'small', variant = 'outlined', sx = {} }) => {
    const config = {
        morning: { color: 'primary', label: 'Morning' },
        evening: { color: 'secondary', label: 'Evening' },
        night: { color: 'warning', label: 'Night' },
    }

    const { color, label } = config[shift?.toLowerCase()] || { color: 'default', label: shift }

    return (
        <Chip
            label={label}
            color={color}
            size={size}
            variant={variant}
            sx={sx}
        />
    )
}
